import React from 'react';
import { golfCarts } from '@data/carts';
import CartCard from '@components/features/CartCard';

interface FleetSectionProps {
  onBookNowClick: () => void;
}

const FleetSection: React.FC<FleetSectionProps> = ({ onBookNowClick }) => {
  return (
    <section id="carts" className="py-12">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold mb-2 text-gray-900">Our Premium 6-Seater Fleet</h2>
        <p className="text-gray-600 mb-8">
          All carts feature lithium batteries for extended range and reliability
        </p>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {golfCarts.map((cart) => (
            <CartCard key={cart.id} cart={cart} onBookClick={onBookNowClick} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FleetSection;